/* NEVERSAD Ruleta: premio con temporizador + "última oportunidad" al abandonar el carrito. */
(function () {
  var root = document.getElementById('nvr');
  if (!root || window.__nvRuleta) return;
  window.__nvRuleta = true;
  // Se renderiza dentro de la ventana del carrito (oculta); se mueve al body para que se vea.
  if (root.parentNode !== document.body) document.body.appendChild(root);

  var KEY = 'nvRuleta';
  var PRIZE_MIN = 30, LAST_MIN = 10;
  var SEGMENTS = [
    { label: '$15.000', code: 'RULETA15', title: '$15.000', sub: 'para gastar en compras desde $150.000', w: 17 },
    { label: '$20.000', code: 'RULETA20', title: '$20.000', sub: 'para gastar en compras desde $150.000', w: 13 },
    { label: 'ENVÍO GRATIS', code: 'RULETAENVIO', title: 'Envío gratis', sub: 'a toda Colombia en tu pedido', w: 17 },
    { label: 'CAMISETA', code: 'RULETACAMISETA', title: 'Camiseta gratis', sub: 'con tu par de tenis', w: 15,
      note: 'Ve al catálogo de camisetas, agrega la que quieras al carrito junto a tus tenis y sale gratis.',
      cta: { href: '/collections/camisetas', label: 'Elegir mi camiseta' } },
    { label: '$15.000', code: 'RULETA15', title: '$15.000', sub: 'para gastar en compras desde $150.000', w: 17 },
    { label: '$40.000 x2', code: 'RULETA2X40', title: '$40.000', sub: 'al comprar 2 pares', w: 8 },
    { label: '$20.000', code: 'RULETA20', title: '$20.000', sub: 'para gastar en compras desde $150.000', w: 13 }
  ];
  var NOTE = 'Ya quedó aplicado. Lo ves al pagar.';
  var LAST = { code: 'ULTIMA30', title: '$30.000' };

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  var state = load();

  if (/[?&]ruleta=reset/.test(location.search)) { state = { bucket: 'A' }; save(state); }
  if (!state.bucket) { state.bucket = Math.random() < 0.5 ? 'A' : 'B'; save(state); }

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return root.querySelectorAll(sel); };
  var page = root.dataset.page;
  var now = function () { return Date.now(); };

  function fmt(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var m = Math.floor(s / 60); s = s % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  function applyCode(code) {
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function () {});
  }
  function clearCode() {
    document.cookie = 'discount_code=; Max-Age=0; path=/';
  }
  function tagCart(value) {
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { Ruleta: value } })
    }).catch(function () {});
  }

  /* ---------- Modal ---------- */
  function showStep(name) {
    $$('.nvr__step').forEach(function (el) { el.hidden = el.dataset.step !== name; });
  }
  function open(step) {
    if (step === 'spin') protectSub();
    root.hidden = false;
    showStep(step);
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (!activeReward()) root.hidden = true;
  }
  $$('[data-nvr-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (!state.played) { state.dismissedAt = now(); save(state); }
      close();
    });
  });
  root.querySelectorAll('[data-nvr-close-go]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  /* ---------- Rueda ---------- */
  function drawWheel() {
    var svg = $('.nvr__wheel');
    var n = SEGMENTS.length, r = 98, cx = 100, cy = 100, html = '';
    SEGMENTS.forEach(function (seg, i) {
      var a0 = (i / n) * 2 * Math.PI - Math.PI / 2, a1 = ((i + 1) / n) * 2 * Math.PI - Math.PI / 2;
      var x0 = cx + r * Math.cos(a0), y0 = cy + r * Math.sin(a0), x1 = cx + r * Math.cos(a1), y1 = cy + r * Math.sin(a1);
      var dark = i % 2 === 0;
      html += '<path d="M' + cx + ' ' + cy + ' L' + x0.toFixed(2) + ' ' + y0.toFixed(2) + ' A' + r + ' ' + r + ' 0 0 1 ' + x1.toFixed(2) + ' ' + y1.toFixed(2) + ' Z" fill="' + (dark ? '#141414' : '#ffffff') + '" stroke="#ffffff" stroke-width="1"/>';
      var mid = (i + 0.5) / n * 360;
      html += '<text x="100" y="34" transform="rotate(' + mid + ' 100 100)" text-anchor="middle" font-family="Poppins, sans-serif" font-weight="700" font-size="' + (seg.label.length > 9 ? 8.5 : 11) + '" fill="' + (dark ? '#ffffff' : '#0a0a0a') + '">' + seg.label + '</text>';
    });
    html += '<circle cx="100" cy="100" r="17" fill="#0a0a0a" stroke="#fff" stroke-width="2"/><text x="100" y="104.5" text-anchor="middle" font-family="Poppins, sans-serif" font-weight="700" font-size="11" fill="#fff">NS</text>';
    svg.innerHTML = html;
  }
  function pick() {
    var total = SEGMENTS.reduce(function (t, s) { return t + s.w; }, 0), x = Math.random() * total;
    for (var i = 0; i < SEGMENTS.length; i++) { x -= SEGMENTS[i].w; if (x < 0) return i; }
    return 0;
  }

  /* Alta en Shopify Email: formulario nativo de Shopify enviado a un iframe oculto.
     Shopify.captcha.protect le activa el hCaptcha invisible de la tienda (sin eso Shopify bloquea el envío). */
  var sub = document.getElementById('nvr-sub');
  function protectSub() {
    try { if (sub && window.Shopify && Shopify.captcha && !sub.dataset.cptcha) Shopify.captcha.protect(sub); } catch (e) {}
  }
  function subscribe(email, tags) {
    if (!sub) return;
    try {
      sub.target = 'nvr-sink';
      sub.querySelector('[name="contact[email]"]').value = email;
      sub.querySelector('[name="contact[tags]"]').value = tags.join(',');
      protectSub();
      var tries = 0;
      (function go() {
        if (!sub.dataset.hcaptchaBound && tries++ < 20) return setTimeout(go, 250);
        if (sub.requestSubmit) sub.requestSubmit(); else sub.submit();
      })();
    } catch (e) {}
  }

  /* ---------- Formulario y giro ---------- */
  var form = $('.nvr__form');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var err = $('.nvr__err');
    var email = form.email.value.trim(), wa = form.wa.value.replace(/\D/g, '');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = 'Escribe un correo válido.'; err.hidden = false; return; }
    if (wa && (wa.length < 10 || wa.length > 12)) { err.textContent = 'Revisa el número de WhatsApp (10 dígitos).'; err.hidden = false; return; }
    if (!form.ok.checked) { err.textContent = 'Debes aceptar para poder girar.'; err.hidden = false; return; }
    err.hidden = true;
    form.querySelector('button').disabled = true;

    var i = pick(), seg = SEGMENTS[i], n = SEGMENTS.length;
    var target = 360 * 6 + (360 - ((i + 0.5) / n) * 360) + (Math.random() * 20 - 10);
    $('.nvr__wheel').style.transform = 'rotate(' + target + 'deg)';

    var tags = ['ruleta', 'premio-' + seg.code];
    if (wa) tags.push('whatsapp-' + (wa.length === 10 ? '57' + wa : wa));
    subscribe(email, tags);

    setTimeout(function () {
      state.played = true;
      state.prize = { code: seg.code, title: seg.title, sub: seg.sub, exp: now() + PRIZE_MIN * 60000 };
      save(state);
      applyCode(seg.code);
      tagCart('A-' + seg.code);
      $('[data-nvr-prize]').textContent = seg.title;
      $('[data-nvr-prize-sub]').textContent = seg.sub;
      setWonCta(seg);
      showStep('won');
      tick();
    }, 4400);
  });

  function setWonCta(seg) {
    var note = $('[data-nvr-note]'), shop = $('[data-nvr-shop]');
    if (note) note.textContent = seg.note || NOTE;
    if (shop && seg.cta) { shop.href = seg.cta.href; shop.textContent = seg.cta.label; shop.dataset.fixed = '1'; }
  }

  /* ---------- Temporizador y barra ---------- */
  function activeReward() {
    var t = now();
    if (state.last && state.last.exp > t && !state.last.done) return { kind: 'last', r: state.last };
    if (state.prize && state.prize.exp > t && !state.prize.done) return { kind: 'prize', r: state.prize };
    return null;
  }
  var bar = $('[data-nvr-bar]');
  var expiredShownFor = null;
  function tick() {
    var a = activeReward(), t = now();
    $$('[data-nvr-clock]').forEach(function (el) {
      var r = el.closest('[data-step="last"]') ? state.last : state.prize;
      if (r) el.textContent = fmt(r.exp - t);
    });
    if (a) {
      root.hidden = false;
      bar.hidden = false; bar.classList.remove('is-expired');
      document.body.classList.add('nvr-has-bar');
      $('[data-nvr-bar-txt]').textContent = 'Tu premio: ' + a.r.title;
      bar.href = a.r.code === 'RULETACAMISETA' ? '/collections/camisetas' : '/cart';
      $('[data-nvr-bar-clock]').textContent = fmt(a.r.exp - t);
      expiredShownFor = null;
      return;
    }
    var r = state.last && !state.last.done ? state.last : (state.prize && !state.prize.done ? state.prize : null);
    if (r && r.exp <= t) {
      r.done = true; save(state); clearCode();
      expiredShownFor = t;
      bar.hidden = false; bar.classList.add('is-expired');
      $('[data-nvr-bar-txt]').textContent = 'Tu premio venció';
      $('[data-nvr-bar-clock]').textContent = '';
    }
    if (expiredShownFor && t - expiredShownFor > 5000) {
      bar.hidden = true; expiredShownFor = null;
      document.body.classList.remove('nvr-has-bar');
      if (!root.classList.contains('is-open')) root.hidden = true;
    }
  }
  setInterval(tick, 1000);

  /* ---------- Última oportunidad (abandono del carrito) ---------- */
  function cartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { return c.item_count; }).catch(function () { return 0; });
  }
  function offerLast() {
    if (state.bucket !== 'A' || !state.played || state.lastOffered) return;
    if (root.classList.contains('is-open')) return;
    cartCount().then(function (count) {
      if (!count || state.lastOffered) return;
      state.lastOffered = true;
      state.last = { code: LAST.code, title: LAST.title, exp: now() + LAST_MIN * 60000 };
      save(state);
      applyCode(LAST.code);
      tagCart('A-' + LAST.code);
      open('last'); tick();
    });
  }
  // 1) Vuelve en otra visita con productos en el carrito
  var newSession = false;
  try { newSession = !sessionStorage.getItem('nvrSess'); sessionStorage.setItem('nvrSess', '1'); } catch (e) {}
  // 2) En computador: el mouse sale por arriba (va a cerrar la pestaña)
  var arrived = now();
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY <= 0 && now() - arrived > 8000) offerLast();
  });
  // 3) En el carrito: se va a otra app y vuelve
  var hiddenAt = 0;
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { hiddenAt = now(); return; }
    if (page === 'cart' && hiddenAt && now() - hiddenAt > 20000) offerLast();
  });

  /* ---------- Marcar el carrito para medir A/B ---------- */
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/add/.test(url) && !state.cartTagged) {
      p.then(function () {
        state.cartTagged = true; save(state);
        var a = activeReward();
        tagCart(state.bucket + (a ? '-' + a.r.code : state.played ? '-jugó' : '-sin jugar'));
      }).catch(function () {});
    }
    return p;
  };

  /* ---------- Inicio ---------- */
  drawWheel();
  var a = activeReward();
  if (a) applyCode(a.r.code);
  tick();
  var shop = $('[data-nvr-shop]');
  cartCount().then(function (c) { if (c && shop && !shop.dataset.fixed) shop.href = '/cart'; });

  if (state.bucket === 'A' && newSession && state.played) setTimeout(offerLast, 2500);

  var canShow = state.bucket === 'A' && !state.played && page !== 'cart' &&
    (!state.dismissedAt || now() - state.dismissedAt > 3 * 86400000);
  if (canShow) {
    var shown = false;
    var show = function () { if (shown) return; shown = true; window.removeEventListener('scroll', onScroll); open('spin'); };
    var onScroll = function () { if (window.scrollY > window.innerHeight * 0.5) show(); };
    setTimeout(show, 6000);
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
